import InputComponent from 'app_components/commons/Input/InputComponent'
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'
import { ICertificateSettingsItem } from 'app_types/admin/certificateSettings/certificateSettings.types'
import React, { FC } from 'react'

import './CertificateSettingsItemForm.scss'

interface ICertificateSettingsItemFormProps {
  value: ICertificateSettingsItem
  onChange: (data: ICertificateSettingsItem) => void
}

const CertificateSettingsItemForm: FC<ICertificateSettingsItemFormProps> = ({
  onChange,
  value
}) => {
  const handleChangeCheckbox = () => {
    const newValue = {...value}
    newValue.status = !value.status
    onChange && onChange(newValue)
  }

  return (
    <div className='certificate-settings-item-form--layout'>
      <div className='certificate-settings-item-form--check'>
        <input
          type='checkbox'
          checked={value?.status}
          onChange={handleChangeCheckbox}
        />
        <LabelComponent>
          Habilitar
        </LabelComponent>
      </div>
      {value?.status && (
        <InputComponent
          type='number'
          disabled
          label='Porcentaje [%]'
          value={String(value?.percentage)}
          style={{ width: '100px' }}
        />
      )}
    </div>
  )
}

export default CertificateSettingsItemForm
